
function calcRemainingLoanMonths(principal, monthlyPayment, annualRate) {
  const r = annualRate / 12;
  
  if (r === 0) {
    return principal / monthlyPayment;
  }
  
  const ratio = (r * principal) / monthlyPayment;
  if (ratio >= 1) {
    // Payment doesn't even cover interest — loan can't be paid off
    return Infinity;
  }
  const nbrMonthsRemaining = -Math.log(1 - ratio) / Math.log(1 + r);
  return nbrMonthsRemaining;
}
export default calcRemainingLoanMonths;
